export default "__VITE_ASSET__Da5mJEyf__"